import React from "react";
import { Typography, Stack, styled } from "@mui/material";
import HyroIconButton from "@hyro-components/hyro-icon-button/HyroIconButton";
import { ICON_BUTTON_VARIANTS, ICON_BUTTON_SIZES } from "@hyro-components/hyro-icon-button/HyroIconButton.consts";
import CopyIcon from "src/icons/CopyIcon";
import CopyPopper from "@hyro-components/CopyPopper";
import HyroTruncateTypography from "@hyro-components/hyro-truncate-typography/HyroTruncateTypography";

const NotificationConfigIdBox = ({ configId }) => (
  <StyledContainer data-testid="config-id-section">
    <Typography variant="subtitle2">Configuration ID</Typography>

    <StyledIdBox>
      <StyledConfigIdRow>
        <HyroTruncateTypography variant="caption" maxWidth="245px">{configId}</HyroTruncateTypography>

        <CopyPopper copyText={configId}>
          <HyroIconButton variant={ICON_BUTTON_VARIANTS.CLEAR} size={ICON_BUTTON_SIZES.MEDIUM}>
            <CopyIcon strokeOpacity={1} />
          </HyroIconButton>
        </CopyPopper>
      </StyledConfigIdRow>
    </StyledIdBox>
  </StyledContainer>
);

const StyledContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.5),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius
}));

const StyledIdBox = styled(Stack)(({ theme }) => ({
  padding: "0 12px",
  justifyContent: "center",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: "4px",
  height: "42px"
}));

const StyledConfigIdRow = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between"
}));

export default NotificationConfigIdBox;

